module.exports = __webpack_public_path__ + "img/logo.2fe1ec0b.png";